import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createCommunityService from '../../services/community/createCommunityService';
import CommunityForm from './CommunityFormModal';

const EMPTY_COMMUNITY = {};

const NewCommunity = ({ open, dispatchCreateCommunityPost, createCommunityFetch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body => dispatchCreateCommunityPost(body, () => navigate(`/communities`), t),
    [dispatchCreateCommunityPost, t, navigate]
  );

  if (!open) return null;

  return (
    <CommunityForm
      header={t('newCommunity')}
      onSubmit={handleSubmit}
      submitProcessing={createCommunityFetch.pending}
      returnRoute="/communities"
      cancelRoute="/communities"
      data={EMPTY_COMMUNITY}
    />
  );
};

NewCommunity.propTypes = {
  dispatchCreateCommunityPost: PropTypes.func.isRequired,
  createCommunityFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewCommunity.defaultProps = { open: false };

export default createCommunityService(NewCommunity);
